import {
	Box,
	Button,
	Typography,
	Modal,
	Paper,
	Dialog,
	Divider,
	DialogContent,
	DialogTitle,
	DialogActions,
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { closeDialog } from '../../services/features/dialogSlice/dialogSlice';
import { RootState } from '../../store';

/**
 * UpdateQuoteStatusModal component displays a confirmation dialog.
 *
 * @param {Object} props - Component props.
 * @param {Function} props.handleConfirm - Function to handle the modal confirm action.
 */
const UpdateQuoteStatusModal = ({ handleConfirm }: { handleConfirm: () => void }) => {
	const dispatch = useDispatch();

	const openState = useSelector((state: RootState) => state.dialogSlice.open);
	const open = openState['updateQuote'];

	const handleClose = () => {
		dispatch(closeDialog('updateQuote'));
	};

	return (
		<Dialog onClose={handleClose} open={open} className='modalConfirmation_container'>
			<DialogTitle>Update Approved Quote?</DialogTitle>
			<DialogContent>
				<Divider />
				<Box pt='1em'>
					<Typography variant='cardSubtitle1'>
						Changes will require re-referral before binding.
					</Typography>
				</Box>
			</DialogContent>
			<DialogActions>
				<Button variant='text' onClick={handleClose}>
					Cancel
				</Button>
				<Button variant='contained' onClick={handleConfirm}>
					Continue
				</Button>
			</DialogActions>
		</Dialog>
	);
};

export default UpdateQuoteStatusModal;
